import { trainingApiClient } from "../../../../../http-common";


export const getAllTrainingAssessmentTestList = async (obj) => {
  return await trainingApiClient.post(`/masters/assessment/list`, obj);
};
export const getTrainingAssessmentInfo = async (id) => {
  return await trainingApiClient.get(`/masters/assessment/getAssessmentById`, {
    params: {
      assessmentId: id,
    },
  });
};
export const getAssessmentTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/assessmentType/dropdown`);
};
export const getOptionTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/optionType/dropdown`);
};
export const getTrainingDropdown = async () => {
  return await trainingApiClient.get(`/masters/training/getTrainingDropdown`);
};
export const saveAssessment = async (obj) => {
  return await trainingApiClient.post(`/masters/assessment/saveAndUpdate`, obj);
};